import Vue from 'vue'
import Vuex from 'vuex'

import * as ProjectStore from './modules/ProjectStore'
import * as UserStore from './modules/UserStore'
import * as AuthStore from './modules/AuthStore'
import * as NotificationStore from './modules/NotificationStore'
import * as MasterplanStore from './modules/MasterplanStore'
import * as PoiStore from './modules/PoiStore'
import * as MenuItemsStore from './modules/MenuItemsStore'
import * as ClientAppStore from './modules/ClientAppStore'
import * as MediaStore from './modules/MediaStore'
import * as MediaManagerStore from './modules/MediaManagerStore'
import * as BuildingStore from './modules/BuildingStore'
import * as ApartmentStore from './modules/ApartmentStore'
import * as ApartmentTypeStore from './modules/ApartmentTypeStore'
import * as ApartmentOrientationStore from './modules/ApartmentOrientationStore'
import * as ContentStore from './modules/ContentStore'
import * as DialogStore from './modules/DialogStore'
import * as BreadcrumbsStore from './modules/BreadcrumbsStore'

Vue.use(Vuex)

export const modules = {
  AuthStore,
  UserStore,
  ProjectStore,
  NotificationStore,
  MasterplanStore,
  PoiStore,
  MenuItemsStore,
  ClientAppStore,
  MediaStore,
  MediaManagerStore,
  BuildingStore,
  ApartmentStore,
  ApartmentTypeStore,
  ApartmentOrientationStore,
  ContentStore,
  DialogStore,
  BreadcrumbsStore
}
const store = new Vuex.Store({
  modules: modules,
  state: {
    organization: {},
    loadingStatus: 'idle',
    errors: [],
    notificationsVisible: false,
    packageVersion: process.env.PACKAGE_VERSION || '0',
    guardBeforeLeaveEnabled: false
  },
  mutations: {
    SET_LOADING_STATUS(state, status) {
      state.loadingStatus = status
    },
    SET_ERRORS(state, data) {
      console.log('SET_ERRORS', data)
      state.errors = state.errors.concat(data)
    },
    CLEAN_ERRORS(state, data) {
      state.errors = data
    },
    GUARD_ENABLED(state, data) {
      state.guardBeforeLeaveEnabled = data
    }
  },
  actions: {
    cleanErrors: function(context) {
      context.commit('CLEAN_ERRORS', [])
    },
    resetState: function(context) {
      for (const currentModule in modules) {
        if (modules[currentModule].state.hasOwnProperty('initialState')) {
          context.dispatch(currentModule + '/resetStore')
        }
      }
    },
    enableGuardBeforeLeave({ commit }, payload) {
      commit('GUARD_ENABLED', true)
    },
    disableGuardBeforeLeave({ commit }) {
      commit('GUARD_ENABLED', false)
    }
  },
  getters: {
    errors: state => {
      return state.errors
    },
    isNotificationsVisible: state => {
      return state.NotificationStore.notifications.length > 0
    },
    appVersion: state => {
      return state.packageVersion
    },
    guardBeforeLeaveEnabled: state => state.guardBeforeLeaveEnabled
  },
  namespaced: true
})

export default store
